<template>
    <v-sheet class="ma-0 pa-0">
        <div class="d-flex mt-2 flex-grow-1 flex-shrink-0 align-center justify-space-around">
                <v-label>Filtra</v-label>
                <v-autocomplete dense outlined
                    class="ml-4"
                    :items="Object.values(families).filter(f => { return f.enabled})"
                    item-text="label"
                    item-value="id"
                    append-icon="filter_list"
                    clearable
                    hide-details
                    v-model="search_family"
                    label="famiglia">
                    </v-autocomplete>
                    <v-autocomplete dense outlined
                    class="ml-2"
                    :items="op_types"
                    apepend-icon="filter_list"
                    item-text="name"
                    item-value="id"
                    clearable
                    hide-details
                    v-model="search_report"
                    label="report">
                </v-autocomplete>
                <v-btn class="ml-6" color="primary" @click="searchProcedures"><v-icon small>search</v-icon></v-btn>
                <v-btn class="ml-2" color="action" @click="clearSearch"><v-icon small>clear</v-icon></v-btn>
            </div>
        <BasicCard v-if="loading" v-bind:title="`Caricamento in corso`" class="pr-2">
            <v-card-text text-center>
                <v-progress-circular
                indeterminate
                size="64"
                width="7"
                color="primary"
                ></v-progress-circular>
            </v-card-text>
        </BasicCard>
        
        <BasicCard v-else>
            <template v-slot:action>
                <v-btn v-can="{obj_type:'procedure', action: 'edit'}"  class="ml-2 white--text" text @click.stop="editProcedure(null)"><v-icon class="pa-2" small>add_box</v-icon> Nuova procedura</v-btn>
            </template>
            <v-data-table
                :headers="headers"
                :items="procedures"
                hide-default-footer
                disable-pagination
                >
                <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="(item, index) of items" :key="index" class="cursor_pointer" @click.stop="viewProcedure(item._id)">
                        <td class="text-left">{{item.name}}</td>
                        <td class="text-left">{{families[item.family].label}}</td>
                        <td class="text-left">{{type[item.op_type].name}}</td>
                        <td class="text-left">{{ item.date | formatDateTS}}</td>
                        <td class="text-left">{{ item.expiry | formatDateTS}}</td>
                        <td class="text-right">
                            <div class="d-flex justify-end">
                                <v-btn v-can="{obj_type:'master', action: 'edit'}" color="primary" class="ma-1" small @click.stop="changeProcedureStatus(item, index)">
                                    <span v-if="item.active">disattiva</span><span v-else>attiva</span>
                                </v-btn>
                                <v-btn v-can="{obj_type:'procedure', action: 'edit'}" color="primary" small fab @click.stop="editProcedure(item._id)"><v-icon small>edit</v-icon></v-btn>
                                <v-btn v-can="{obj_type:'procedure', action: 'remove'}"  color="primary" small fab @click.stop="openDeleteConfirm(index, item)"><v-icon small>delete</v-icon></v-btn>
                            </div>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-data-table> 
        </BasicCard>
        <div v-if="procedures.length > 0" class="text-center pa-2">
            <div class="text-right font-italic font-small">Totale: {{ procedures.length }}</div>
        </div>
        <ConfirmDialog
            v-bind:data="delete_confirm"
            v-on:close_dialog="closeDialog"
            v-on:confirm_result="onDeleteConfirm"/>
    </v-sheet>
</template>

<script>
// import _ from 'lodash'
import ConfirmDialog from '../../components/dialogs/ConfirmDialog'
import {i_families, report_type} from "../../utils/common.js"
import BasicCard from '../../components/utils/Basic_card'
export default {
    components:{ConfirmDialog, BasicCard},
    data(){
        return {
            headers: [
                {text: 'nome', value: 'name', align:'left', sortable: false},
                {text: 'famiglia', value: 'family', align:'left', sortable: false},
                {text: 'tipo', value: 'op_type', align:'left', sortable: false},
                {text: 'emissione', value: 'date', align:'left', sortable: false},
                {text: 'scadenza', value: 'date', align:'left', sortable: false},
            ],
            families: i_families,
            loading: true,
            procedures: [],
            op_types: Object.values(report_type).filter(item => item.enabled),
            search_family: null,
            search_report: null,
            sources_db: [
                {"value": "masters", "text": "definitivi"},
                {"value": "temporary", "text": "temporanei"}
            ],
            delete_confirm: {
                index: null,
                dialog: false,
                doc: null,
                title: 'Elimina procedura',
                message: "Sei sicuro di voler rimuovere la procedura selezionato?",
                choices: [
                    {key: "cancel", val: "annulla", mod: "success"},
                    {key: "delete", val: "elimina"}
                    ]
                },
            type: report_type
        }
    },
    methods: {
        async searchProcedures(){
            this.loading = true
            let selector = {doc_type: 'procedure'}
            if (this.search_family!=null){
                selector['family'] = this.search_family
            }
            if (this.search_report!=null){
                selector['op_type'] = this.search_report
            }
            this.$store.commit('setSearchParam', { path: this.$router.history.current.fullPath, filter: {search_family: this.search_family, search_report: this.search_report} })
            
            console.log('selector', selector)
            let res = await this.$store.state.$pouch.find('registry', {
                selector: selector
            })
            console.log("$$ res", res.docs)
            this.procedures = res.docs
            this.loading=false
        },
        openDeleteConfirm(index, doc){
            console.log('DELETE', index, doc)
            this.delete_confirm.dialog = true;
            this.delete_confirm.index = index;
            this.delete_confirm.doc = doc;
        },
        editProcedure(p_id) {
            this.$router.push({name: "editProcedure", query: {p_id: p_id, clone:false}})
        },
        viewProcedure(p_id) {
            this.$router.push({name: "editProcedure", query: {p_id: p_id, clone:false, preview:"true"}})
        },

        async onDeleteConfirm(choice){
            try {
                if(choice == "delete"){
                    let doc = _.cloneDeep(this.delete_confirm.doc)
                    doc._deleted = true
                    doc.updated_by = this.$store.state.user._id
                    doc.updated = (new Date()).getTime()
                    let res = await this.$store.state.$pouch.put('registry', doc)
                    if (res.ok) {
                        this.procedures.splice(this.delete_confirm.index, 1)
                        console.log('procedure removed')
                    }
                }
                this.closeDialog()
            } catch(error) {
                console.log('error', error)
            }
        },
        closeDialog(){
            this.delete_confirm.dialog = false;
        },
        async changeProcedureStatus(item) {
            try {
                let proc = await this.$store.state.$pouch.get('registry', item._id)
                if (proc.active == item.active && proc._rev == item._rev) {
                    proc.active = !proc.active;
                    proc.updated_by = this.$store.state.user._id
                    proc.updated = (new Date()).getTime()
                    let res = await this.$store.state.$pouch.put('registry', proc)
                    if (res.ok) {
                        item.active = proc.active
                        this.$set(item, '_rev', res.rev)
                    }
                } else {
                    // force reload page
                }
            } catch (error) {
                console.log('error', error)
            }
        },
        clearSearch() {
            this.search_family = null
            this.search_report = null
            this.searchProcedures()
        },
    },
    mounted(){
        let filter = this.$store.state.search[this.$router.history.current.fullPath]
        if (filter) {
            if (filter.search_family!=null){
                this.search_family = filter.search_family
            }
            if (filter.search_report!=null){
                this.search_report = filter.search_report
            }
        }
        this.searchProcedures()
    },
    
}
</script>
